import { addMethod, string } from "yup";

addMethod(string, "greaterThanZero", function (message: string) {
  return this.test("greater-than-zero", message, (value) => {
    if (!value) return false;
    return Number(value) > 0;
  });
});

declare module "yup" {
  interface StringSchema {
    greaterThanZero(message: string): this;
  }
}
